// FUNCTION TO INSERT CURRENT DATE IN INPUTS [TYPE=DATE]
export function controlDate() {
  const date = new Date();

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const currentDate = `${year}-${month}-${day}`;

  const inputDate = document.querySelectorAll('input[type="date"]')

  inputDate.forEach((input) => {
    input.value = currentDate;
    input.min = currentDate;

    input.addEventListener('blur', () => {
      if(input.value < currentDate) {
        input.value = currentDate;
      }
    });
  });
}
